import type { Recipe } from '../contexts/RecipeContext';
import { createCompressedCache } from './compressedCache';

const REFRESH_DELAY = 30 * 60 * 1000; // 30 minutes

const slimRecipe = (recipe: Recipe): Partial<Recipe> => ({
  _id: recipe._id,
  _timestamp_ms: recipe._timestamp_ms, // CRITICAL: incremental sync compares this
  name: recipe.name,
  batchSize: recipe.batchSize,
  boilTime: recipe.boilTime,
  efficiency: recipe.efficiency,
  style: recipe.style,
  defaults: recipe.defaults,
  equipment: recipe.equipment,
  brewer: recipe.brewer,
  author: recipe.author,
  nutrition: recipe.nutrition,
  yeast: recipe.yeast,
  fermentables: recipe.fermentables || [],
  hops: recipe.hops || [],
  yeasts: recipe.yeasts || [],
  miscs: recipe.miscs || [],
});

export const recipeCache = createCompressedCache<Recipe>({
  storageKey: 'brewfather_recipes_cache',
  lastRefreshKey: 'brewfather_recipes_cache_last_refresh',
  refreshDelayMs: REFRESH_DELAY,
  slim: slimRecipe,
});

export const getCachedRecipes = (): Recipe[] | null => recipeCache.get();
export const setCachedRecipes = (recipes: Recipe[]): void => recipeCache.set(recipes);
export const clearRecipesCache = (): void => recipeCache.clear();
export const shouldRefreshRecipeCache = (): boolean => recipeCache.shouldRefresh();
